"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendableError = void 0;
var extendable_error_1 = require("./extendable-error");
Object.defineProperty(exports, "ExtendableError", { enumerable: true, get: function () { return extendable_error_1.ExtendableError; } });
//# sourceMappingURL=index.js.map